import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/mazda6.jpg'
import _imports_1 from '@/assets/images/honda.jpg'
import _imports_2 from '@/assets/images/garage.jpg'


const _hoisted_1 = { class: "carousel-inner" }
const _hoisted_2 = ["aria-hidden"]
const _hoisted_3 = ["aria-hidden"]
const _hoisted_4 = ["aria-hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "main-carousel",
    class: "carousel slide carousel-fade font-weight-bold text-uppercase",
    role: "region",
    "aria-roledescription": "karuzela",
    "aria-label": "Usługi warsztatu",
    onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args))),
    onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resume && _ctx.resume(...args))),
    onFocusin: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args))),
    onFocusout: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resume && _ctx.resume(...args))),
    onKeydown: [
      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)), ["prevent"]), ["left"])),
      _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)), ["prevent"]), ["right"]))
    ],
    onTouchstartPassive: _cache[8] || (_cache[8] = ($event: any) => (_ctx.touchStart = $event.changedTouches[0].clientX)),
    onTouchendPassive: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.swipe && _ctx.swipe(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["carousel-item", { active: _ctx.activeSlide === 0 }]),
        "aria-hidden": _ctx.activeSlide !== 0
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("img", {
          class: "d-block w-100",
          src: _imports_0,
          alt: "Warsztat blacharsko - lakierniczy"
        }, null, -1),
        _createElementVNode("div", { class: "carousel-caption" }, [
          _createElementVNode("h3", null, [
            _createTextVNode(" Warsztat"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "text-primary" }, "blacharsko"),
            _createElementVNode("br"),
            _createTextVNode(" lakierniczy ")
          ])
        ], -1)
      ]))], 10, _hoisted_2),
      _createElementVNode("div", {
        class: _normalizeClass(["carousel-item", { active: _ctx.activeSlide === 1 }]),
        "aria-hidden": _ctx.activeSlide !== 1
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("img", {
          class: "d-block w-100",
          src: _imports_1,
          alt: "Kompleksowe naprawy bezgotówkowe"
        }, null, -1),
        _createElementVNode("div", { class: "carousel-caption" }, [
          _createElementVNode("h3", null, [
            _createTextVNode(" Kompleksowe"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "text-primary" }, "naprawy"),
            _createElementVNode("br"),
            _createTextVNode(" bezgotówkowe ")
          ])
        ], -1)
      ]))], 10, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass(["carousel-item", { active: _ctx.activeSlide === 2 }]),
        "aria-hidden": _ctx.activeSlide !== 2
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("img", {
          class: "d-block w-100",
          src: _imports_2,
          alt: "Pełna obsługa powypadkowa"
        }, null, -1),
        _createElementVNode("div", { class: "carousel-caption" }, [
          _createElementVNode("h3", null, [
            _createTextVNode(" Pełna"),
            _createElementVNode("br"),
            _createElementVNode("span", { class: "text-primary" }, "obsługa"),
            _createElementVNode("br"),
            _createTextVNode(" powypadkowa ")
          ])
        ], -1)
      ]))], 10, _hoisted_4)
    ]),
    _createElementVNode("button", {
      class: "carousel-control-prev",
      type: "button",
      "aria-controls": "main-carousel",
      "aria-label": "Poprzedni slajd",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args)))
    }, [...(_cache[13] || (_cache[13] = [
      _createElementVNode("span", {
        class: "carousel-control-prev-icon",
        "aria-hidden": "true"
      }, null, -1)
    ]))]),
    _createElementVNode("button", {
      class: "carousel-control-next",
      type: "button",
      "aria-controls": "main-carousel",
      "aria-label": "Następny slajd",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
    }, [...(_cache[14] || (_cache[14] = [
      _createElementVNode("span", {
        class: "carousel-control-next-icon",
        "aria-hidden": "true"
      }, null, -1)
    ]))])
  ], 32))
}